<template>
  <div :data-clazz="model.clazz">
    <div class="panelTitle">{{ i18n['handleNode'] }}</div>
    <div class="panelBody">
      <DefaultDetail :model="model" :on-change="onChange" :read-only="readOnly" />
      <div class="panelRow">
        <div>之后任务：</div>
        <a-select
          :disabled="readOnly"
          :filterOption="true"
          :value="model.task"
          @change="(e) => onChange('task', e)"
          mode="multiple"
          placeholder="选择任务"
          style="width:90%; font-size:12px"
        >
          <a-select-option
            :key="taskIndex"
            :value="taskValue.full_name"
            v-for="(taskValue, taskIndex) in tasks"
          >{{taskValue.name}}</a-select-option>
        </a-select>
      </div>
      <div class="panelRow">
        <div>
          <span style="color: red">*</span>
          {{ i18n['handleNode.assignType'] }}：
        </div>
        <a-select
          :disabled="readOnly"
          :placeholder="i18n['handleNode.assignType.placeholder']"
          :value="model.assignType"
          @change="(e) => { onChange('assignValue', []); onChange('assignType', e); assignmentType() }"
          size="small"
          style="width:90%; font-size: 12px"
        >
          <a-select-option key="person" value="person">{{i18n['handleNode.assignType.person']}}</a-select-option>
          <a-select-option key="role" value="role">{{i18n['userTask.assignType.role']}}</a-select-option>
          <!-- <a-select-option key="persongroup" value="persongroup" :title="i18n['handleNode.assignType.persongroup']"/> -->
          <a-select-option key="department" value="department">{{i18n['handleNode.assignType.department']}}</a-select-option>
          <a-select-option key="variable" value="variable">{{i18n['handleNode.assignType.variable']}}</a-select-option>
        </a-select>
      </div>
      <div class="panelRow" v-if="model.assignType === 'person'">
        <div>
          <span style="color: red">*</span>
          {{ i18n['handleNode.assignType.person.title'] }}：
        </div>
        <a-select
          :disabled="readOnly"
          :filterOption="true"
          :placeholder="i18n['handleNode.assignType.person.placeholder']"
          :value="model.assignValue"
          @change="(e) => { onChange('assignValue', e); getPersons(e) }"
          mode="multiple"
          style="width:90%; font-size:12px"
        >
          <a-select-option
            :key="user.userId"
            :value="user.userId"
            v-for="user in users"
          >{{user.nickName===''?user.username:user.nickName}}</a-select-option>
        </a-select>
      </div>
      <div class="panelRow" v-else-if="model.assignType === 'role'">
        <div>
          <span style="color: red">*</span>
          {{ i18n['userTask.assignType.role.title'] }}：
        </div>
        <a-select
          :disabled="readOnly"
          :placeholder="i18n['userTask.assignType.role.placeholder']"
          @change="(e) => { onChange('assignValue', e); getPersons(e) }"
          mode="multiple"
          style="width:90%; font-size:12px"
          v-model.number="model.assignValue"
        >
          <a-select-option :key="index" :value="item.roleId" v-for="(item, index) in roles">{{item.roleName}}</a-select-option>
        </a-select>
      </div>
      <!-- <div v-else-if="model.assignType === 'persongroup'" class="panelRow">
        <div>{{ i18n['handleNode.assignType.persongroup.title'] }}：</div>
        <a-select
          style="width:90%; font-size:12px"
          :placeholder="i18n['handleNode.assignType.persongroup.placeholder']"
          :value="model.assignValue"
          :disabled="readOnly"
          mode="multiple"
          :filterOption="true"
          @change="(e) => { onChange('assignValue', e); getPersons(e) }"
        >
          <a-select-option v-for="group in groups" :key="group.id" :title="group.nickname===''?group.name:group.nickname" :value="group.id" />
        </a-select>
      </div>-->
      <div class="panelRow" v-else-if="model.assignType === 'department'">
        <div>
          <span style="color: red">*</span>
          {{ i18n['userTask.assignType.department.title'] }}：
        </div>
        <a-select
          :disabled="readOnly"
          :filterOption="true"
          :placeholder="i18n['userTask.assignType.department.placeholder']"
          :value="model.assignValue"
          @change="(e) => { onChange('assignValue', e); getPersons(e) }"
          mode="multiple"
          size="small"
          style="width:90%; font-size:12px"
        >
          <a-select-option
            :key="department.id"
            :value="department.id"
            v-for="department in departments"
          >{{department.tenantId}}-{{department.departName}}</a-select-option>
        </a-select>
      </div>
      <div class="panelRow" v-else-if="model.assignType === 'variable'">
        <div>
          <span style="color: red">*</span>
          {{ i18n['handleNode.assignType.variable.title'] }}：
        </div>
        <a-select
          :disabled="readOnly"
          :filterOption="true"
          :placeholder="i18n['handleNode.assignType.variable.placeholder']"
          @change="(e) => { onChange('assignValue', e); getPersons(e) }"
          mode="multiple"
          size="small"
          style="width:90%; font-size:12px"
          v-model.number="model.assignValue"
        >
          <a-select-option :key="index" :value="item.value" v-for="(item, index) in variableOptions">{{item.label}}</a-select-option>
        </a-select>
      </div>
      <div class="panelRow">
        <a-checkbox
          :disabled="model.assignType !== 'role' && model.assignType !== 'department' && (
            model.assignValue===undefined ||
            model.assignValue===null ||
            model.assignValue.length <= 1 ||
            model.activeOrder ||
            readOnly)"
          :value="model.isCounterSign"
          @change="(e) => { onChange('isCounterSign', e); initCounterSign(e) }"
        >{{ i18n['handleNode.counterSign'] }}</a-checkbox>
        <a-checkbox
          :disabled="model.assignValue===undefined||model.assignValue===null||model.assignValue.length <= 1||model.isCounterSign||readOnly"
          :value="model.activeOrder"
          @change="(value) => onChange('activeOrder', value)"
        >主动接单</a-checkbox>
        <a-checkbox
          :value="model.fullHandle"
          @change="(value) => onChange('fullHandle', value)"
          size="small"
          v-if="(model.assignType === 'role' || model.assignType === 'department') &&
            model.assignValue!==undefined &&
            model.assignValue!==null &&
            model.assignValue.length >= 1 &&
            model.isCounterSign"
        >{{ i18n['userTask.fullHandle'] }}</a-checkbox>
      </div>
      <NodeDetail
        :model="model"
        :on-change="onChange"
        :read-only="readOnly"
        :readonly-preview="false"
        :templates="templates"
        :templates-base="templatesBase"
        :users="users"
      />
    </div>
  </div>
</template>
<script>
  import DefaultDetail from './DefaultDetail'
  import NodeDetail from './NodeDetail'
  export default {
    inject: ['i18n'],
    components: {
      DefaultDetail,
      NodeDetail
    },
    props: {
      model: {
        type: Object,
        default: () => ({})
      },
      users: {
        type: Array,
        default: () => ([])
      },
      roles: {
        type: Array,
        default: () => ([])
      },
      groups: {
        type: Array,
        default: () => ([])
      },
      departments: {
        type: Array,
        default: () => ([])
      },
      tasks: {
        type: Array,
        default: () => ([])
      },
      onChange: {
        type: Function,
        default: () => { }
      },
      readOnly: {
        type: Boolean,
        default: false
      },
      templates: {
        type: Array,
        default: () => ([])
      },
      templatesBase: {
        type: Array,
        default: () => ([])
      }
    },
    data () {
      return {
        variableOptions: [{
          value: 1,
          label: '创建者'
        }, {
          value: 2,
          label: '创建者负责人'
        }],
        roleList: []
      }
    },
    methods: {
      getPersons (e) {
        if (e === undefined || e === null || e.length <= 1) {
          this.onChange('activeOrder', false)
          this.onChange('isCounterSign', false)
        }
      },
      initCounterSign (e) {
        if (!e) {
          this.onChange('fullHandle', false)
        }
      },
      assignmentType () {
        this.onChange('isCounterSign', false)
      }
    }
  }
</script>
